import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Your privacy is important to us. It is Kamran Ayub's policy to respect your privacy regarding any information we may collect from you through our app, Reach FI.`}</p>
    <p>{`We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.`}</p>
    <p>{`We do not retain any data entered on the site. All data is stored on your device or web browser and can be cleared at any time. `}</p>
    <p>{`Some device data is collected by a third-party service provider `}<a parentName="p" {...{
        "href": "https://azure.microsoft.com/en-us/services/monitor/"
      }}>{`Microsoft Azure Monitor`}</a>{` for technical assessment, service reliability, and crash reporting. Data is stored for 7 days before being destroyed. Data stored on Microsoft Azure is subject to separate `}<a parentName="p" {...{
        "href": "https://azure.microsoft.com/en-us/support/legal/"
      }}>{`privacy and terms of service`}</a>{`. No user-entered data or information is sent to this service provider.`}</p>
    <p>{`What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.`}</p>
    <p>{`We don’t share any personally identifying information publicly or with third-parties, except when required to by law.`}</p>
    <p>{`Our app may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.`}</p>
    <p>{`You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.`}</p>
    <p>{`Your continued use of our app will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.`}</p>
    <p>{`This policy is effective as of 19 February 2019.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      